import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';

export const errorStatus = (
    err: FetchBaseQueryError | SerializedError | undefined
): string | number | undefined =>
    err && 'status' in err ? err.status : undefined;

// An empty base URL resolves relative to the cockpit's own origin and
// completes as a normal (wrong) response rather than throwing — so a missing
// env var can't be inferred from the error shape, only checked directly.
export const MISCONFIGURED_MESSAGE =
    'Assistant nicht konfiguriert. Ist VITE_ASSISTANT_API_URL gesetzt?';

// Reachable-but-unreachable failures a set URL can still produce: refused
// connection, a non-JSON response from the wrong host, or a timeout.
const CONNECTION_ERROR_STATUSES = new Set([
    'FETCH_ERROR',
    'PARSING_ERROR',
    'TIMEOUT_ERROR',
]);
export const isConnectionError = (
    err: FetchBaseQueryError | SerializedError | undefined
): boolean => {
    const status = errorStatus(err);
    return typeof status === 'string' && CONNECTION_ERROR_STATUSES.has(status);
};
